import React, {useRef, useState} from "react"
import productPageImg from "../../../../assets/website-images/client/client-banner-image.png"
import productBannerImg from "../../../../assets/website-images/product/product-banner.jpg";
import {useInView} from "framer-motion";
import PageBanner from "../../../components/website/pages-banner/PageBanner";
import {Col, Container, Row} from "react-bootstrap";
import img1 from "../../../../assets/website-images/client/c1.png";
import img2 from "../../../../assets/website-images/client/c2.png";
import img3 from "../../../../assets/website-images/client/c3.png";
import "./client.scss"
import {useTranslation} from "react-i18next";

export default function ClientPage() {
    const {t} = useTranslation();
    const ref3 = useRef(null);
    const ref = useRef(null);
    const isInView3 = useInView(ref3, { once: true });
    const isInView = useInView(ref, { once: true }); // Only trigger once
    const [activeSection, setActiveSection] = useState(1);
    const containerVariants2 = {
        hidden: { opacity: 1 },
        show: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3, // Staggering the animation of each child by 0.3 seconds
            },
        },
    };
    const cardVariants = {
        hidden: { opacity: 0, x: -100 }, // Start with opacity 0 and 100px to the left
        show: { opacity: 1, x: 0 },      // Fade in and move to original position
    };


    const handleSectionClick = (sectionIndex) => {
        setActiveSection(sectionIndex);
    };

    return(
        <div className={'client-page'}>
            <PageBanner img={productPageImg} heading={t('client.banner_head')} bannerImg={productBannerImg}/>

            <div className={'section-3'}>
                <Container>
                    <Row>
                        <Col lg={5}>
                            <div className="headers">
                                <div>
                                    <h4
                                        className={'subheading'}
                                    >
                                        {t('client.sub_head')}
                                    </h4>
                                    <h2
                                        className={'heading'}
                                    >
                                        {t('client.head')}
                                    </h2>
                                </div>

                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} lg={4}>
                            <div className={'client-box'}>
                                <img src={img1}/>
                                <p>{t('client.client1_para_1')}</p>
                                <p>{t('client.client1_para_2')}</p>
                            </div>

                        </Col>
                        <Col md={6} lg={4}>
                            <div className={'client-box'}>
                                <img src={img2}/>
                                <p>{t('client.client3_para_1')}</p>
                                <p>{t('client.client3_para_2')}</p>
                            </div>

                        </Col>
                        <Col md={6} lg={4}>
                            <div className={'client-box'}>
                                <img src={img3}/>
                                <p>{t('client.client2_para_1')}</p>
                                <p>{t('client.client2_para_2')}</p>
                                <p>{t('client.client2_para_3')}</p>
                              </div>

                        </Col>
                    </Row>
                </Container>
            </div>

        </div>
    )
}